import { css } from '@compiled/react';
import PropTypes from 'prop-types';

import type { GlyphProps } from '@atlaskit/icon/types';

import { wacToken } from '@/libraries/design/foundations';

type MenuIconProps = GlyphProps & {
	lightMode?: boolean;
};

export const MenuIcon: React.FC<MenuIconProps> = ({ lightMode = false }) => {
	const strokeColor = lightMode
		? wacToken('color.neutral.light0')
		: wacToken('color.primary.black');

	return (
		<div
			css={css({
				width: '21px',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				gap: '4px',
			})}
		>
			<svg xmlns="http://www.w3.org/2000/svg" width="25" height="4" viewBox="0 0 25 4" fill="none">
				<path d="M2 2H23" stroke={strokeColor} strokeWidth="3" strokeLinecap="round" />
			</svg>
			<svg xmlns="http://www.w3.org/2000/svg" width="25" height="4" viewBox="0 0 25 4" fill="none">
				<path d="M2 2H23" stroke={strokeColor} strokeWidth="3" strokeLinecap="round" />
			</svg>
			<svg xmlns="http://www.w3.org/2000/svg" width="25" height="4" viewBox="0 0 25 4" fill="none">
				<path d="M2 2H23" stroke={strokeColor} strokeWidth="3" strokeLinecap="round" />
			</svg>
		</div>
	);
};

MenuIcon.propTypes = {
	lightMode: PropTypes.bool,
};
